import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { SharedModule } from '../../../shared/shared.module';
import { IdentificationTypeTableComponent } from './identification-type-table.component';

@NgModule({
  declarations: [IdentificationTypeTableComponent],
  imports: [
    CommonModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    MultiSelectModule,
    DropdownModule,
    SharedModule,
  ],
  exports: [IdentificationTypeTableComponent],
})
export class IdentificationTypeTableModule {}
